import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import HeroSlider from "../components/HeroSlider";
import Phone from "../components/Phone";
import imgLogo from "../assets/images/logo.png";
import imgHomepage from "../assets/images/Homepage.png";
import imgExplore from "../assets/images/Explore.png";
import imgLangExchange from "../assets/images/Language Exchange.png";
import imgLiveAudience from "../assets/images/Live Room (Audience).png";
import imgLiveHost from "../assets/images/Live Room (Host).png";
import imgLowBalance from "../assets/images/Low Balance Warning.png";
import imgMyRooms from "../assets/images/My Rooms.png";
import imgNearbyRooms from "../assets/images/Nearby Rooms.png";
import imgRoomDetails from "../assets/images/Room Details.png";
import imgSearching from "../assets/images/Searching For Call.png";
import imgSendGift from "../assets/images/Send a Gift.png";
import imgTrending from "../assets/images/Trending Rooms.png";

const FEATURES = [
  { ic: "🎙️", h: "Live interest rooms", p: "Voice & video rooms built around a topic — Kannada practice, morning motivation, book clubs. Raise your hand or just listen in." },
  { ic: "📹", h: "Instant voice & video", p: "One tap to call when it clicks. Send gifts mid-call, chat alongside, share your screen to teach." },
  { ic: "🛡️", h: "Trust & verification", p: "ID + selfie checks, reputation scores, and women-only mode. Safety is the product, not a setting." },
  { ic: "🤝", h: "Skill buddies & accountability", p: "Grow together — coding partners, UPSC groups, fitness circles. Reputation, not follower counts." },
];

const GALLERY = [
  { label: "Home",       src: imgHomepage,    alt: "Home screen" },
  { label: "Explore",    src: imgExplore,     alt: "Explore screen" },
  { label: "Nearby",     src: imgNearbyRooms, alt: "Nearby rooms" },
  { label: "Trending",   src: imgTrending,    alt: "Trending rooms" },
  { label: "My Rooms",   src: imgMyRooms,     alt: "My rooms" },
  { label: "Room",       src: imgRoomDetails, alt: "Room details" },
  { label: "Host",       src: imgLiveHost,    alt: "Live room host view" },
  { label: "Audience",   src: imgLiveAudience,alt: "Live room audience view" },
  { label: "Call",       src: imgSearching,   alt: "Searching for a call" },
  { label: "Language",   src: imgLangExchange,alt: "Language exchange" },
  { label: "Gift",       src: imgSendGift,    alt: "Send a gift" },
  { label: "Wallet",     src: imgLowBalance,  alt: "Low balance warning" },
];

const INTERESTS = [
  ["c", "🌐 Language Exchange"], ["m", "🎤 Public Speaking"], ["v", "🧘 Wellness"],
  ["c", "🎸 Music"], ["m", "✈️ Travel Partners"], ["v", "📚 Book Clubs"],
  ["c", "💪 Fitness"], ["m", "🍳 Cooking"], ["v", "♟️ Chess"], ["c", "💻 Coding"],
  ["m", "🏙️ City & Culture"], ["v", "📸 Photography"], ["c", "🎨 Art"],
  ["m", "🚀 Startups"], ["v", "🧗 Trekking"],
];

const REVIEWS = [
  { t: "I found my Kannada practice partner here and now we're genuine friends. The rooms make it so easy to just start talking — no pressure, no weirdness.", n: "Ananya R.", r: "Bengaluru", av: "https://i.pravatar.cc/150?img=47" },
  { t: "Moved to a new city and Instafrnd helped me meet locals who actually share my interests. The verification made me feel safe meeting people.", n: "Rohit M.", r: "Hyderabad", av: "https://i.pravatar.cc/150?img=12" },
  { t: "As a creator I host wellness rooms every morning. The gifting and coins make it rewarding, and the community is so warm and respectful.", n: "Priya S.", r: "Mumbai", av: "https://i.pravatar.cc/150?img=32" },
];

export default function Home() {
  return (
    <>
      <Helmet>
        <title>Instafrnd — Find Your IF | India's Social Connection App</title>
        <meta name="description" content="Connect through live rooms, voice & video calls, and gifting based on what you love. Join 10M+ users on Instafrnd. Not a dating app." />
        <link rel="canonical" href="https://instafrnd.com/" />
        <meta property="og:url" content="https://instafrnd.com/" />
        <meta property="og:title" content="Instafrnd — Find Your IF | India's Social Connection App" />
        <meta property="og:description" content="Connect through live rooms, voice & video calls, and gifting based on what you love. Join 10M+ users on Instafrnd. Not a dating app." />
      </Helmet>
      <HeroSlider />

      {/* APP PITCH CARD */}
      <section className="pitch">
        <div className="wrap">
          <div className="pitch-card reveal">
            <div>
              <div className="pitch-head">
                <div className="pitch-icon" style={{ padding: 8, overflow: "hidden", background: "#fff", border: "1px solid var(--line)", boxShadow: "0 6px 18px rgba(16,24,40,.08)" }}>
                    <img src={imgLogo} alt="Instafrnd" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                  </div>
                <div>
                  <h3>Instafrnd: Talk to Friends Online</h3>
                  <p>India's Safest Friendship App</p>
                </div>
              </div>
              {/* <div className="pitch-stats">
                <div className="pstat"><div className="n">4.6<span className="star">★</span></div><div className="l">120K reviews</div></div>
                <div className="pstat"><div className="n">10M+</div><div className="l">Downloads</div></div>
                <div className="pstat"><div className="n">12+</div><div className="l">Rated for 12+</div></div>
              </div> */}
              <ul className="pitch-list">
                <li><span className="tk">✓</span> Match on intent — interests, languages, goals, not looks</li>
                <li><span className="tk">✓</span> Voice &amp; video rooms with verified people</li>
                <li><span className="tk">✓</span> Send gifts, earn coins, build your reputation</li>
              </ul>
              <div className="store-row">
                <button className="btn btn-primary">▶ Download Now</button>
                <button className="btn btn-ghost">◈ Recharge Coins</button>
              </div>
            </div>
            <div className="pitch-media">
              <Phone variant="pitch" label="App preview" src={imgHomepage} alt="Instafrnd home screen" />
            </div>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="features" id="features">
        <div className="wrap">
          <div className="sec-head reveal">
            <div className="kicker">What makes Instafrnd special</div>
            <h2>Connection with a purpose.</h2>
          </div>
          <div className="feat-grid">
            <div className="feat-list">
              {FEATURES.map((f, k) => (
                <div className="feat reveal" key={k} style={{ transitionDelay: `${k * 0.06}s` }}>
                  <div className="ic">{f.ic}</div>
                  <div>
                    <h3>{f.h}</h3>
                    <p>{f.p}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="feat-media reveal">
              <div className="feat-glow" />
              <Phone variant="feature" label="Live rooms" src={imgLiveHost} alt="Live room host view" />
            </div>
          </div>
        </div>
      </section>

      {/* GALLERY */}
      <section className="section-pad" id="screens">
        <div className="wrap">
          <div className="sec-head reveal">
            <div className="kicker">Inside the app</div>
            <h2>Swipe through the experience.</h2>
          </div>
        </div>
        <div
          className="reveal"
          style={{ display: "flex", gap: 16, overflowX: "auto", padding: "6px 16px 26px", scrollSnapType: "x mandatory", WebkitOverflowScrolling: "touch" }}
        >
          {GALLERY.map((g, k) => (
            <div
              key={k}
              className="g-phone"
            >
              <div className="g-phone-scr">
                <img src={g.src} alt={g.alt} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* INTERESTS */}
      <section className="interests" id="interests">
        <div className="wrap">
          <div className="sec-head reveal">
            <div className="kicker">Your interests</div>
            <h2>Whatever your IF is — someone's into it too.</h2>
          </div>
          <div className="cloud reveal">
            {INTERESTS.map(([c, label], k) => (
              <span className={`tag ${c}`} key={k}>{label}</span>
            ))}
          </div>
        </div>
      </section>

      {/* REVIEWS */}
      <section className="reviews" id="reviews">
        <div className="wrap">
          <div className="sec-head reveal">
            <div className="kicker">Our users love us</div>
            <h2>Real people, real connections.</h2>
          </div>
          <div className="review-grid">
            {REVIEWS.map((rv, k) => (
              <div className="review reveal" key={k} style={{ transitionDelay: `${k * 0.08}s` }}>
                <div className="stars">★★★★★</div>
                <p>"{rv.t}"</p>
                <div className="reviewer">
                  <img src={rv.av} alt={rv.n} style={{ width: 46, height: 46, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }} />
                  <div>
                    <div className="nm">{rv.n}</div>
                    <div className="role">{rv.r}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SAFETY */}
      <section className="safety" id="safety">
        <div className="wrap">
          <div className="safety-grid">
            <div className="reveal">
              <div className="kicker" style={{ justifyContent: "flex-start" }}>Safety first</div>
              <h2>Connection you can trust.</h2>
              <p style={{ color: "var(--muted)", fontSize: 18 }}>
                In India, trust is everything. We built verification, reputation,
                and women's safety into the core — so you always know who you're
                talking to.
              </p>
              <ul className="safety-list">
                <li><span className="tk">✓</span> Multi-level ID &amp; selfie verification with liveness</li>
                <li><span className="tk">✓</span> Reputation score from real interactions</li>
                <li><span className="tk">✓</span> Women-only discovery mode</li>
                <li><span className="tk">✓</span> AI moderation &amp; instant reporting</li>
                <li><span className="tk">✓</span> City-level location only — never your exact spot</li>
              </ul>
              <div style={{ marginTop: 24 }}>
                <Link className="btn btn-primary" to="/safety">Visit Safety Center →</Link>
              </div>
            </div>
            <div className="reveal" style={{ transitionDelay: "0.12s" }}>
              <div className="safety-card">
                <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 20 }}>
                  <img src="https://i.pravatar.cc/150?img=32" alt="Priya S." style={{ width: 56, height: 56, borderRadius: "50%", objectFit: "cover" }} />
                  <div>
                    <div style={{ fontWeight: 700, fontSize: 18, display: "flex", alignItems: "center", gap: 8 }}>
                      Priya S. <span style={{ color: "var(--cyan)", fontSize: 14 }}>🛡️ Verified</span>
                    </div>
                    <div style={{ color: "var(--muted)", fontSize: 14 }}>⭐ 4.9 · Trusted Member · Bengaluru</div>
                  </div>
                </div>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 22 }}>
                  <span className="tag c" style={{ padding: "7px 14px", fontSize: 13 }}>Kannada</span>
                  <span className="tag v" style={{ padding: "7px 14px", fontSize: 13 }}>Yoga</span>
                  <span className="tag m" style={{ padding: "7px 14px", fontSize: 13 }}>Photography</span>
                </div>
                <div style={{ display: "flex", gap: 10 }}>
                  <button className="btn btn-primary" style={{ flex: 1, justifyContent: "center" }}>📞 Voice</button>
                  <button className="btn btn-ghost" style={{ flex: 1, justifyContent: "center" }}>📹 Video</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* INVESTORS / PRESS */}
      <section className="investors">
        <div className="wrap">
          <div className="lbl reveal">Trusted &amp; recognised by</div>
          <div className="inv-row reveal">
            <span className="inv">YourStory</span>
            <span className="inv">Inc42</span>
            <span className="inv">ET Tech</span>
            <span className="inv">Startup India</span>
            <span className="inv">Bharat Founders</span>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-sec">
        <div className="wrap">
          <div className="cta reveal">
            <div className="kicker">Your IF is waiting</div>
            <h2>Stop scrolling. Start connecting.</h2>
            <p>Download Instafrnd and find the people who are into exactly what you're into.</p>
            <div className="store-row" style={{ justifyContent: "center" }}>
              <button className="btn btn-primary">▶ Get it on Android</button>
              <button className="btn btn-ghost"> Download for iOS</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
